import Product from 'cpc-license-manager/models/product';
import { belongsTo } from '@ember-data/model';

class Quality extends Product {
  @belongsTo('station-feature', { async: false, inverse: null, embedded: true }) features;

  name = 'quality';
  label = 'Quality';
}

export default Quality;
